module.exports = __webpack_public_path__ + "static/media/facebook.7c25ab9a.png";